export default __webpack_public_path__ + "static/media/pgmico(36).843a02c3.png";